import * as jsxRuntime from "D:\\lydianlabs\\04_센딧\\sendit\\messaging-frontend.2차.원본\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment